<template>
  <div class="navbar-elements">
    <navbar-links />
    <div class="theme-switcher">
      <theme-switcher />
    </div>
    <div class="language-switcher">
      <language-switcher />
    </div>
  </div>
</template>

<script>
import NavbarLinks from "./NavbarLinks";
import ThemeSwitcher from "./ThemeSwitcher";
import LanguageSwitcher from "./LanguageSwitcher";

export default {
  name: "NavbarElements",
  components: {
    ThemeSwitcher,
    NavbarLinks,
    LanguageSwitcher
  }
}
</script>

<style scoped>
.navbar-elements {
  display: flex;
  flex-direction: row;
}

@media only screen and (max-width : 768px) {
  .navbar-elements {
    display: none;
  }
}

.theme-switcher, .language-switcher{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
}
</style>